import { ICitizenship } from "@/@types/_shared/documents/citizenship";
const AU: ICitizenship = {
  code2: "AU",
  code3: "AUS",
  subject: "Австралия",
};

const AT: ICitizenship = {
  code2: "AT",
  code3: "AUT",
  subject: "Австрия",
};

const AZ: ICitizenship = {
  code2: "AZ",
  code3: "AZE",
  subject: "Азербайджан",
};

const AX: ICitizenship = {
  code2: "AX",
  code3: "ALA",
  subject: "Аландские Острова",
};

const AL: ICitizenship = {
  code2: "AL",
  code3: "ALB",
  subject: "Албания",
};

const DZ: ICitizenship = {
  code2: "DZ",
  code3: "DZA",
  subject: "Алжир",
};

const AS: ICitizenship = {
  code2: "AS",
  code3: "ASM",
  subject: "Американское Самоа",
};

const AI: ICitizenship = {
  code2: "AI",
  code3: "AIA",
  subject: "Ангилья",
};

const AO: ICitizenship = {
  code2: "AO",
  code3: "AGO",
  subject: "Ангола",
};

const AD: ICitizenship = {
  code2: "AD",
  code3: "AND",
  subject: "Андорра",
};

const AQ: ICitizenship = {
  code2: "AQ",
  code3: "ATA",
  subject: "Антарктика",
};

const AG: ICitizenship = {
  code2: "AG",
  code3: "ATG",
  subject: "Антигуа и Барбуда",
};

const AR: ICitizenship = {
  code2: "AR",
  code3: "ARG",
  subject: "Аргентина",
};

const AM: ICitizenship = {
  code2: "AM",
  code3: "ARM",
  subject: "Армения",
};

const AW: ICitizenship = {
  code2: "AW",
  code3: "ABW",
  subject: "Аруба",
};

const AF: ICitizenship = {
  code2: "AF",
  code3: "AFG",
  subject: "Афганистан",
};

const BS: ICitizenship = {
  code2: "BS",
  code3: "BHS",
  subject: "Багамы",
};

const BD: ICitizenship = {
  code2: "BD",
  code3: "BGD",
  subject: "Бангладеш",
};

const BB: ICitizenship = {
  code2: "BB",
  code3: "BRB",
  subject: "Барбадос",
};

const BH: ICitizenship = {
  code2: "BH",
  code3: "BHR",
  subject: "Бахрейн",
};

const BY: ICitizenship = {
  code2: "BY",
  code3: "BLR",
  subject: "Беларусь",
};

const BZ: ICitizenship = {
  code2: "BZ",
  code3: "BLZ",
  subject: "Белиз",
};

const BE: ICitizenship = {
  code2: "BE",
  code3: "BEL",
  subject: "Бельгия",
};

const BJ: ICitizenship = {
  code2: "BJ",
  code3: "BEN",
  subject: "Бенин",
};

const BM: ICitizenship = {
  code2: "BM",
  code3: "BMU",
  subject: "Бермуды",
};

const BG: ICitizenship = {
  code2: "BG",
  code3: "BGR",
  subject: "Болгария",
};

const BO: ICitizenship = {
  code2: "BO",
  code3: "BOL",
  subject: "Боливия, Многонациональное Государство",
};

const BQ: ICitizenship = {
  code2: "BQ",
  code3: "BES",
  subject: "Бонейр, Синт-Эстатиус и Саба",
};

const BA: ICitizenship = {
  code2: "BA",
  code3: "BIH",
  subject: "Босния и Герцеговина",
};

const BW: ICitizenship = {
  code2: "BW",
  code3: "BWA",
  subject: "Ботсвана",
};

const BR: ICitizenship = {
  code2: "BR",
  code3: "BRA",
  subject: "Бразилия",
};

const IO: ICitizenship = {
  code2: "IO",
  code3: "IOT",
  subject: "Британская Территория в Индийском океане",
};

const BN: ICitizenship = {
  code2: "BN",
  code3: "BRN",
  subject: "Бруней-Даруссалам",
};

const BF: ICitizenship = {
  code2: "BF",
  code3: "BFA",
  subject: "Буркина-Фасо",
};

const BI: ICitizenship = {
  code2: "BI",
  code3: "BDI",
  subject: "Бурунди",
};

const BT: ICitizenship = {
  code2: "BT",
  code3: "BTN",
  subject: "Бутан",
};

const MK: ICitizenship = {
  code2: "MK",
  code3: "MKD",
  subject: "Бывшая югославская Республика Македония",
};

const VU: ICitizenship = {
  code2: "VU",
  code3: "VUT",
  subject: "Вануату",
};

const HU: ICitizenship = {
  code2: "HU",
  code3: "HUN",
  subject: "Венгрия",
};

const VE: ICitizenship = {
  code2: "VE",
  code3: "VEN",
  subject: "Венесуэла, Боливарианская Республика",
};

const VG: ICitizenship = {
  code2: "VG",
  code3: "VGB",
  subject: "Виргинские Острова (британские)",
};

const VI: ICitizenship = {
  code2: "VI",
  code3: "VIR",
  subject: "Виргинские Острова (США)",
};

const UM: ICitizenship = {
  code2: "UM",
  code3: "UMI",
  subject: "Внешние малые острова (США)",
};

const VN: ICitizenship = {
  code2: "VN",
  code3: "VNM",
  subject: "Вьетнам",
};

const GA: ICitizenship = {
  code2: "GA",
  code3: "GAB",
  subject: "Габон",
};

const GY: ICitizenship = {
  code2: "GY",
  code3: "GUY",
  subject: "Гайана",
};

const HT: ICitizenship = {
  code2: "HT",
  code3: "HTI",
  subject: "Гаити",
};

const GM: ICitizenship = {
  code2: "GM",
  code3: "GMB",
  subject: "Гамбия",
};

const GH: ICitizenship = {
  code2: "GH",
  code3: "GHA",
  subject: "Гана",
};

const GP: ICitizenship = {
  code2: "GP",
  code3: "GLP",
  subject: "Гваделупа",
};

const GT: ICitizenship = {
  code2: "GT",
  code3: "GTM",
  subject: "Гватемала",
};

const GN: ICitizenship = {
  code2: "GN",
  code3: "GIN",
  subject: "Гвинея",
};

const GW: ICitizenship = {
  code2: "GW",
  code3: "GNB",
  subject: "Гвинея-Бисау",
};

const DE: ICitizenship = {
  code2: "DE",
  code3: "DEU",
  subject: "Германия",
};

const GG: ICitizenship = {
  code2: "GG",
  code3: "GGY",
  subject: "Гернси",
};

const GI: ICitizenship = {
  code2: "GI",
  code3: "GIB",
  subject: "Гибралтар",
};

const HN: ICitizenship = {
  code2: "HN",
  code3: "HND",
  subject: "Гондурас",
};

const HK: ICitizenship = {
  code2: "HK",
  code3: "HKG",
  subject: "Гонконг, особый административный район Китая",
};

const PS: ICitizenship = {
  code2: "PS",
  code3: "PSE",
  subject: "Государство Палестина",
};

const GD: ICitizenship = {
  code2: "GD",
  code3: "GRD",
  subject: "Гренада",
};

const GL: ICitizenship = {
  code2: "GL",
  code3: "GRL",
  subject: "Гренландия",
};

const GR: ICitizenship = {
  code2: "GR",
  code3: "GRC",
  subject: "Греция",
};

const GE: ICitizenship = {
  code2: "GE",
  code3: "GEO",
  subject: "Грузия",
};

const GU: ICitizenship = {
  code2: "GU",
  code3: "GUM",
  subject: "Гуам",
};

const DK: ICitizenship = {
  code2: "DK",
  code3: "DNK",
  subject: "Дания",
};

const JE: ICitizenship = {
  code2: "JE",
  code3: "JEY",
  subject: "Джерси",
};

const DJ: ICitizenship = {
  code2: "DJ",
  code3: "DJI",
  subject: "Джибути",
};

const DM: ICitizenship = {
  code2: "DM",
  code3: "DMA",
  subject: "Доминика",
};

const DO: ICitizenship = {
  code2: "DO",
  code3: "DOM",
  subject: "Доминиканская Республика",
};

const EG: ICitizenship = {
  code2: "EG",
  code3: "EGY",
  subject: "Египет",
};

const ZM: ICitizenship = {
  code2: "ZM",
  code3: "ZMB",
  subject: "Замбия",
};

const EH: ICitizenship = {
  code2: "EH",
  code3: "ESH",
  subject: "Западная Сахара",
};

const ZW: ICitizenship = {
  code2: "ZW",
  code3: "ZWE",
  subject: "Зимбабве",
};

const IL: ICitizenship = {
  code2: "IL",
  code3: "ISR",
  subject: "Израиль",
};

const IN: ICitizenship = {
  code2: "IN",
  code3: "IND",
  subject: "Индия",
};

const ID: ICitizenship = {
  code2: "ID",
  code3: "IDN",
  subject: "Индонезия",
};

const JO: ICitizenship = {
  code2: "JO",
  code3: "JOR",
  subject: "Иордания",
};

const IQ: ICitizenship = {
  code2: "IQ",
  code3: "IRQ",
  subject: "Ирак",
};

const IR: ICitizenship = {
  code2: "IR",
  code3: "IRN",
  subject: "Иран (Исламская Республика)",
};

const IE: ICitizenship = {
  code2: "IE",
  code3: "IRL",
  subject: "Ирландия",
};

const IS: ICitizenship = {
  code2: "IS",
  code3: "ISL",
  subject: "Исландия",
};

const ES: ICitizenship = {
  code2: "ES",
  code3: "ESP",
  subject: "Испания",
};

const IT: ICitizenship = {
  code2: "IT",
  code3: "ITA",
  subject: "Италия",
};

const YE: ICitizenship = {
  code2: "YE",
  code3: "YEM",
  subject: "Йемен",
};

const CV: ICitizenship = {
  code2: "CV",
  code3: "CPV",
  subject: "Кабо-Верде",
};

const KZ: ICitizenship = {
  code2: "KZ",
  code3: "KAZ",
  subject: "Казахстан",
};

const KY: ICitizenship = {
  code2: "KY",
  code3: "CYM",
  subject: "Каймановы Острова",
};

const KH: ICitizenship = {
  code2: "KH",
  code3: "KHM",
  subject: "Камбоджа",
};

const CM: ICitizenship = {
  code2: "CM",
  code3: "CMR",
  subject: "Камерун",
};

const CA: ICitizenship = {
  code2: "CA",
  code3: "CAN",
  subject: "Канада",
};

const QA: ICitizenship = {
  code2: "QA",
  code3: "QAT",
  subject: "Катар",
};

const KE: ICitizenship = {
  code2: "KE",
  code3: "KEN",
  subject: "Кения",
};

const CY: ICitizenship = {
  code2: "CY",
  code3: "CYP",
  subject: "Кипр",
};

const KI: ICitizenship = {
  code2: "KI",
  code3: "KIR",
  subject: "Кирибати",
};

const CN: ICitizenship = {
  code2: "CN",
  code3: "CHN",
  subject: "Китай",
};

const CC: ICitizenship = {
  code2: "CC",
  code3: "CCK",
  subject: "Кокосовые Острова (Килинг)",
};

const CO: ICitizenship = {
  code2: "CO",
  code3: "COL",
  subject: "Колумбия",
};

const KM: ICitizenship = {
  code2: "KM",
  code3: "COM",
  subject: "Коморские Острова",
};

const CG: ICitizenship = {
  code2: "CG",
  code3: "COG",
  subject: "Конго",
};

const CD: ICitizenship = {
  code2: "CD",
  code3: "COD",
  subject: "Конго, Демократическая Республика",
};

const KP: ICitizenship = {
  code2: "KP",
  code3: "PRK",
  subject: "Корейская Народно-Демократическая Республика",
};

const CR: ICitizenship = {
  code2: "CR",
  code3: "CRI",
  subject: "Коста-Рика",
};

const CI: ICitizenship = {
  code2: "CI",
  code3: "CIV",
  subject: "Кот-д'Ивуар",
};

const CU: ICitizenship = {
  code2: "CU",
  code3: "CUB",
  subject: "Куба",
};

const KW: ICitizenship = {
  code2: "KW",
  code3: "KWT",
  subject: "Кувейт",
};

const KG: ICitizenship = {
  code2: "KG",
  code3: "KGZ",
  subject: "Кыргызстан",
};

const CW: ICitizenship = {
  code2: "CW",
  code3: "CUW",
  subject: "Кюрасао",
};

const LA: ICitizenship = {
  code2: "LA",
  code3: "LAO",
  subject: "Лаосская Народно-Демократическая Республика",
};

const LV: ICitizenship = {
  code2: "LV",
  code3: "LVA",
  subject: "Латвия",
};

const LS: ICitizenship = {
  code2: "LS",
  code3: "LSO",
  subject: "Лесото",
};

const LR: ICitizenship = {
  code2: "LR",
  code3: "LBR",
  subject: "Либерия",
};

const LB: ICitizenship = {
  code2: "LB",
  code3: "LBN",
  subject: "Ливан",
};

const LY: ICitizenship = {
  code2: "LY",
  code3: "LBY",
  subject: "Ливия",
};

const LT: ICitizenship = {
  code2: "LT",
  code3: "LTU",
  subject: "Литва",
};

const LI: ICitizenship = {
  code2: "LI",
  code3: "LIE",
  subject: "Лихтенштейн",
};

const LU: ICitizenship = {
  code2: "LU",
  code3: "LUX",
  subject: "Люксембург",
};

const MU: ICitizenship = {
  code2: "MU",
  code3: "MUS",
  subject: "Маврикий",
};

const MR: ICitizenship = {
  code2: "MR",
  code3: "MRT",
  subject: "Мавритания",
};

const MG: ICitizenship = {
  code2: "MG",
  code3: "MDG",
  subject: "Мадагаскар",
};

const YT: ICitizenship = {
  code2: "YT",
  code3: "MYT",
  subject: "Майотта",
};

const MO: ICitizenship = {
  code2: "MO",
  code3: "MAC",
  subject: "Макао, особый административный район Китая",
};

const MW: ICitizenship = {
  code2: "MW",
  code3: "MWI",
  subject: "Малави",
};

const MY: ICitizenship = {
  code2: "MY",
  code3: "MYS",
  subject: "Малайзия",
};

const ML: ICitizenship = {
  code2: "ML",
  code3: "MLI",
  subject: "Мали",
};

const MV: ICitizenship = {
  code2: "MV",
  code3: "MDV",
  subject: "Мальдивы",
};

const MT: ICitizenship = {
  code2: "MT",
  code3: "MLT",
  subject: "Мальта",
};

const MA: ICitizenship = {
  code2: "MA",
  code3: "MAR",
  subject: "Марокко",
};

const MQ: ICitizenship = {
  code2: "MQ",
  code3: "MTQ",
  subject: "Мартиник",
};

const MH: ICitizenship = {
  code2: "MH",
  code3: "MHL",
  subject: "Маршалловы Острова",
};

const MX: ICitizenship = {
  code2: "MX",
  code3: "MEX",
  subject: "Мексика",
};

const FM: ICitizenship = {
  code2: "FM",
  code3: "FSM",
  subject: "Микронезия (Федеративные Штаты)",
};

const MZ: ICitizenship = {
  code2: "MZ",
  code3: "MOZ",
  subject: "Мозамбик",
};

const MC: ICitizenship = {
  code2: "MC",
  code3: "MCO",
  subject: "Монако",
};

const MN: ICitizenship = {
  code2: "MN",
  code3: "MNG",
  subject: "Монголия",
};

const MS: ICitizenship = {
  code2: "MS",
  code3: "MSR",
  subject: "Монтсеррат",
};

const MM: ICitizenship = {
  code2: "MM",
  code3: "MMR",
  subject: "Мьянма",
};

const NA: ICitizenship = {
  code2: "NA",
  code3: "NAM",
  subject: "Намибия",
};

const NR: ICitizenship = {
  code2: "NR",
  code3: "NRU",
  subject: "Науру",
};

const NT: ICitizenship = {
  code2: "NT",
  code3: "NTZ",
  subject: "Нейтральная Зона",
};

const NP: ICitizenship = {
  code2: "NP",
  code3: "NPL",
  subject: "Непал",
};

const NE: ICitizenship = {
  code2: "NE",
  code3: "NER",
  subject: "Нигер",
};

const NG: ICitizenship = {
  code2: "NG",
  code3: "NGA",
  subject: "Нигерия",
};

const AN: ICitizenship = {
  code2: "AN",
  code3: "ANT",
  subject: "Нидерландские Антильские Острова",
};

const NL: ICitizenship = {
  code2: "NL",
  code3: "NLD",
  subject: "Нидерланды",
};

const NI: ICitizenship = {
  code2: "NI",
  code3: "NIC",
  subject: "Никарагуа",
};

const NU: ICitizenship = {
  code2: "NU",
  code3: "NIU",
  subject: "Ниуэ",
};

const NZ: ICitizenship = {
  code2: "NZ",
  code3: "NZL",
  subject: "Новая Зеландия",
};

const NC: ICitizenship = {
  code2: "NC",
  code3: "NCL",
  subject: "Новая Каледония",
};

const NO: ICitizenship = {
  code2: "NO",
  code3: "NOR",
  subject: "Норвегия",
};

const AE: ICitizenship = {
  code2: "AE",
  code3: "ARE",
  subject: "Объединенные Арабские Эмираты",
};

const OM: ICitizenship = {
  code2: "OM",
  code3: "OMN",
  subject: "Оман",
};

const BV: ICitizenship = {
  code2: "BV",
  code3: "BVT",
  subject: "Остров Буве",
};

const IM: ICitizenship = {
  code2: "IM",
  code3: "IMN",
  subject: "Остров Мэн",
};

const NF: ICitizenship = {
  code2: "NF",
  code3: "NFK",
  subject: "Остров Норфолк",
};

const CX: ICitizenship = {
  code2: "CX",
  code3: "CXR",
  subject: "Остров Рождества",
};

const CK: ICitizenship = {
  code2: "CK",
  code3: "COK",
  subject: "Острова Кука",
};

const SH: ICitizenship = {
  code2: "SH",
  code3: "SHN",
  subject: "Острова Святой Елены, Вознесения и Тристан-да-Кунья",
};

const TC: ICitizenship = {
  code2: "TC",
  code3: "TCA",
  subject: "Острова Теркс и Кайкос",
};

const WF: ICitizenship = {
  code2: "WF",
  code3: "WLF",
  subject: "Острова Уоллис и Футуна",
};

const HM: ICitizenship = {
  code2: "HM",
  code3: "HMD",
  subject: "Острова Херд и Макдональд",
};

const PK: ICitizenship = {
  code2: "PK",
  code3: "PAK",
  subject: "Пакистан",
};

const PA: ICitizenship = {
  code2: "PA",
  code3: "PAN",
  subject: "Панама",
};

const PW: ICitizenship = {
  code2: "PW",
  code3: "PLW",
  subject: "Палау",
};

const PG: ICitizenship = {
  code2: "PG",
  code3: "PNG",
  subject: "Папуа-Новая Гвинея",
};

const PY: ICitizenship = {
  code2: "PY",
  code3: "PRY",
  subject: "Парагвай",
};

const PE: ICitizenship = {
  code2: "PE",
  code3: "PER",
  subject: "Перу",
};

const PN: ICitizenship = {
  code2: "PN",
  code3: "PCN",
  subject: "Питкэрн",
};

const PL: ICitizenship = {
  code2: "PL",
  code3: "POL",
  subject: "Польша",
};

const PT: ICitizenship = {
  code2: "PT",
  code3: "PRT",
  subject: "Португалия",
};

const PR: ICitizenship = {
  code2: "PR",
  code3: "PRI",
  subject: "Пуэрто-Рико",
};

const KR: ICitizenship = {
  code2: "KR",
  code3: "KOR",
  subject: "Республика Корея",
};

const MD: ICitizenship = {
  code2: "MD",
  code3: "MDA",
  subject: "Республика Молдова",
};

const RE: ICitizenship = {
  code2: "RE",
  code3: "REU",
  subject: "Реюньон",
};

const RU: ICitizenship = {
  code2: "RU",
  code3: "RUS",
  subject: "Российская Федерация",
};

const RW: ICitizenship = {
  code2: "RW",
  code3: "RWA",
  subject: "Руанда",
};

const RO: ICitizenship = {
  code2: "RO",
  code3: "ROU",
  subject: "Румыния",
};

const SV: ICitizenship = {
  code2: "SV",
  code3: "SLV",
  subject: "Сальвадор",
};

const WS: ICitizenship = {
  code2: "WS",
  code3: "WSM",
  subject: "Самоа",
};

const SM: ICitizenship = {
  code2: "SM",
  code3: "SMR",
  subject: "Сан-Марино",
};

const ST: ICitizenship = {
  code2: "ST",
  code3: "STP",
  subject: "Сан-Томе и Принсипи",
};

const SA: ICitizenship = {
  code2: "SA",
  code3: "SAU",
  subject: "Саудовская Аравия",
};

const SZ: ICitizenship = {
  code2: "SZ",
  code3: "SWZ",
  subject: "Свазиленд",
};

const VA: ICitizenship = {
  code2: "VA",
  code3: "VAT",
  subject: "Святейший Престол (государство - город Ватикан)",
};

const MP: ICitizenship = {
  code2: "MP",
  code3: "MNP",
  subject: "Северные Марианские Острова",
};

const SC: ICitizenship = {
  code2: "SC",
  code3: "SYC",
  subject: "Сейшельские Острова",
};

const BL: ICitizenship = {
  code2: "BL",
  code3: "BLM",
  subject: "Сен-Бартелеми",
};

const SN: ICitizenship = {
  code2: "SN",
  code3: "SEN",
  subject: "Сенегал",
};

const MF: ICitizenship = {
  code2: "MF",
  code3: "MAF",
  subject: "Сен-Мартен (французская часть)",
};

const PM: ICitizenship = {
  code2: "PM",
  code3: "SPM",
  subject: "Сен-Пьер и Микелон",
};

const VC: ICitizenship = {
  code2: "VC",
  code3: "VCT",
  subject: "Сент-Винсент и Гренадины",
};

const KN: ICitizenship = {
  code2: "KN",
  code3: "KNA",
  subject: "Сент-Китс и Невис",
};

const LC: ICitizenship = {
  code2: "LC",
  code3: "LCA",
  subject: "Сент-Люсия",
};

const RS: ICitizenship = {
  code2: "RS",
  code3: "SRB",
  subject: "Сербия",
};

const SG: ICitizenship = {
  code2: "SG",
  code3: "SGP",
  subject: "Сингапур",
};

const SX: ICitizenship = {
  code2: "SX",
  code3: "SXM",
  subject: "Синт-Мартен (голландская часть)",
};

const SY: ICitizenship = {
  code2: "SY",
  code3: "SYR",
  subject: "Сирийская Арабская Республика",
};

const SK: ICitizenship = {
  code2: "SK",
  code3: "SVK",
  subject: "Словакия",
};

const SI: ICitizenship = {
  code2: "SI",
  code3: "SVN",
  subject: "Словения",
};

const GB: ICitizenship = {
  code2: "GB",
  code3: "GBR",
  subject: "Соединенное Королевство - гражданин",
};

const GBD: ICitizenship = {
  code2: "GB",
  code3: "GBD",
  subject: "Соединенное Королевство - гражданин зависимых территорий",
};

const GBN: ICitizenship = {
  code2: "GB",
  code3: "GBN",
  subject:
    "Соединенное Королевство - британский подданный (заморские территории)",
};

const GBO: ICitizenship = {
  code2: "GB",
  code3: "GBO",
  subject: "Соединенное Королевство - гражданин заморских территорий",
};

const GBP: ICitizenship = {
  code2: "GB",
  code3: "GBP",
  subject: "Соединенное Королевство - лицо под британским покровительством",
};

const GBS: ICitizenship = {
  code2: "GB",
  code3: "GBS",
  subject: "Соединенное Королевство - британский подданный",
};

const US: ICitizenship = {
  code2: "US",
  code3: "USA",
  subject: "Соединенные Штаты Америки",
};

const SB: ICitizenship = {
  code2: "SB",
  code3: "SLB",
  subject: "Соломоновы Острова",
};

const SO: ICitizenship = {
  code2: "SO",
  code3: "SOM",
  subject: "Сомали",
};

const SD: ICitizenship = {
  code2: "SD",
  code3: "SDN",
  subject: "Судан",
};

const SR: ICitizenship = {
  code2: "SR",
  code3: "SUR",
  subject: "Суринам",
};

const SL: ICitizenship = {
  code2: "SL",
  code3: "SLE",
  subject: "Сьерра-Леоне",
};

const TJ: ICitizenship = {
  code2: "TJ",
  code3: "TJK",
  subject: "Таджикистан",
};

const TW: ICitizenship = {
  code2: "TW",
  code3: "TWN",
  subject: "Тайвань, провинция Китая",
};

const TH: ICitizenship = {
  code2: "TH",
  code3: "THA",
  subject: "Таиланд",
};

const TZ: ICitizenship = {
  code2: "TZ",
  code3: "TZA",
  subject: "Танзания, Объединенная Республика",
};

const TL: ICitizenship = {
  code2: "TL",
  code3: "TLS",
  subject: "Тимор-Лешти",
};

const TG: ICitizenship = {
  code2: "TG",
  code3: "TGO",
  subject: "Того",
};

const TK: ICitizenship = {
  code2: "TK",
  code3: "TKL",
  subject: "Токелау",
};

const TO: ICitizenship = {
  code2: "TO",
  code3: "TON",
  subject: "Тонга",
};

const TT: ICitizenship = {
  code2: "TT",
  code3: "TTO",
  subject: "Тринидад и Тобаго",
};

const TV: ICitizenship = {
  code2: "TV",
  code3: "TUV",
  subject: "Тувалу",
};

const TN: ICitizenship = {
  code2: "TN",
  code3: "TUN",
  subject: "Тунис",
};

const TM: ICitizenship = {
  code2: "TM",
  code3: "TKM",
  subject: "Туркменистан",
};

const TR: ICitizenship = {
  code2: "TR",
  code3: "TUR",
  subject: "Турция",
};

const UG: ICitizenship = {
  code2: "UG",
  code3: "UGA",
  subject: "Уганда",
};

const UZ: ICitizenship = {
  code2: "UZ",
  code3: "UZB",
  subject: "Узбекистан",
};

const UA: ICitizenship = {
  code2: "UA",
  code3: "UKR",
  subject: "Украина",
};

const UY: ICitizenship = {
  code2: "UY",
  code3: "URY",
  subject: "Уругвай",
};

const FO: ICitizenship = {
  code2: "FO",
  code3: "FRO",
  subject: "Фарерские Острова",
};

const FJ: ICitizenship = {
  code2: "FJ",
  code3: "FJI",
  subject: "Фиджи",
};

const PH: ICitizenship = {
  code2: "PH",
  code3: "PHL",
  subject: "Филиппины",
};

const FI: ICitizenship = {
  code2: "FI",
  code3: "FIN",
  subject: "Финляндия",
};

const FK: ICitizenship = {
  code2: "FK",
  code3: "FLK",
  subject: "Фолклендские Острова",
};

const FR: ICitizenship = {
  code2: "FR",
  code3: "FRA",
  subject: "Франция",
};

const GF: ICitizenship = {
  code2: "GF",
  code3: "GUF",
  subject: "Французская (Мальвинские) Гайана",
};

const PF: ICitizenship = {
  code2: "PF",
  code3: "PYF",
  subject: "Французская Полинезия",
};

const TF: ICitizenship = {
  code2: "TF",
  code3: "ATF",
  subject: "Французские Южные Территории",
};

const HR: ICitizenship = {
  code2: "HR",
  code3: "HRV",
  subject: "Хорватия",
};

const CF: ICitizenship = {
  code2: "CF",
  code3: "CAF",
  subject: "Центральноафриканская Республика",
};

const TD: ICitizenship = {
  code2: "TD",
  code3: "TCD",
  subject: "Чад",
};

const ME: ICitizenship = {
  code2: "ME",
  code3: "MNE",
  subject: "Черногория",
};

const CZ: ICitizenship = {
  code2: "CZ",
  code3: "CZE",
  subject: "Чешская Республика",
};

const CL: ICitizenship = {
  code2: "CL",
  code3: "CHL",
  subject: "Чили",
};

const CH: ICitizenship = {
  code2: "CH",
  code3: "CHE",
  subject: "Швейцария",
};

const SE: ICitizenship = {
  code2: "SE",
  code3: "SWE",
  subject: "Швеция",
};

const SJ: ICitizenship = {
  code2: "SJ",
  code3: "SJM",
  subject: "Шпицберген и Ян-Майен",
};

const LK: ICitizenship = {
  code2: "LK",
  code3: "LKA",
  subject: "Шри-Ланка",
};

const EC: ICitizenship = {
  code2: "EC",
  code3: "ECU",
  subject: "Эквадор",
};

const GQ: ICitizenship = {
  code2: "GQ",
  code3: "GNQ",
  subject: "Экваториальная Гвинея",
};

const ER: ICitizenship = {
  code2: "ER",
  code3: "ERI",
  subject: "Эритрея",
};

const EE: ICitizenship = {
  code2: "EE",
  code3: "EST",
  subject: "Эстония",
};

const ET: ICitizenship = {
  code2: "ET",
  code3: "ETH",
  subject: "Эфиопия",
};

const ZA: ICitizenship = {
  code2: "ZA",
  code3: "ZAF",
  subject: "Южная Африка",
};

const GS: ICitizenship = {
  code2: "GS",
  code3: "SGS",
  subject: "Южная Георгия и Южные Сандвичевы Острова",
};

const SS: ICitizenship = {
  code2: "SS",
  code3: "SSD",
  subject: "Южный Судан",
};

const JM: ICitizenship = {
  code2: "JM",
  code3: "JAM",
  subject: "Ямайка",
};

const JP: ICitizenship = {
  code2: "JP",
  code3: "JPN",
  subject: "Япония",
};
export const countryCodes = [
  RU,
  BY,
  UA,
  KZ,
  AU,
  AT,
  AZ,
  AX,
  AL,
  DZ,
  AS,
  AI,
  AO,
  AD,
  AQ,
  AG,
  AR,
  AM,
  AW,
  AF,
  BS,
  BD,
  BB,
  BH,
  BZ,
  BE,
  BJ,
  BM,
  BG,
  BO,
  BQ,
  BA,
  BW,
  BR,
  IO,
  BN,
  BF,
  BI,
  BT,
  MK,
  VU,
  HU,
  VE,
  VG,
  VI,
  UM,
  VN,
  GA,
  GY,
  HT,
  GM,
  GH,
  GP,
  GT,
  GN,
  GW,
  DE,
  GG,
  GI,
  HN,
  HK,
  PS,
  GD,
  GL,
  GR,
  GE,
  GU,
  DK,
  JE,
  DJ,
  DM,
  DO,
  EG,
  ZM,
  EH,
  ZW,
  IL,
  IN,
  ID,
  JO,
  IQ,
  IR,
  IE,
  IS,
  ES,
  IT,
  YE,
  CV,
  KY,
  KH,
  CM,
  CA,
  QA,
  KE,
  CY,
  KI,
  CN,
  CC,
  CO,
  KM,
  CG,
  CD,
  KP,
  CR,
  CI,
  CU,
  KW,
  KG,
  CW,
  LA,
  LV,
  LS,
  LR,
  LB,
  LY,
  LT,
  LI,
  LU,
  MU,
  MR,
  MG,
  YT,
  MO,
  MW,
  MY,
  ML,
  MV,
  MT,
  MA,
  MQ,
  MH,
  MX,
  FM,
  MZ,
  MC,
  MN,
  MS,
  MM,
  NA,
  NR,
  NT,
  NP,
  NE,
  NG,
  AN,
  NL,
  NI,
  NU,
  NZ,
  NC,
  NO,
  AE,
  OM,
  BV,
  IM,
  NF,
  CX,
  CK,
  SH,
  TC,
  WF,
  HM,
  PK,
  PA,
  PW,
  PG,
  PY,
  PE,
  PN,
  PL,
  PT,
  PR,
  KR,
  MD,
  RE,
  RW,
  RO,
  SV,
  WS,
  SM,
  ST,
  SA,
  SZ,
  VA,
  MP,
  SC,
  BL,
  SN,
  MF,
  PM,
  VC,
  KN,
  LC,
  RS,
  SG,
  SX,
  SY,
  SK,
  SI,
  GB,
  US,
  SB,
  SO,
  SD,
  SR,
  SL,
  TJ,
  TW,
  TH,
  TZ,
  TL,
  TG,
  TK,
  TO,
  TT,
  TV,
  TN,
  TM,
  TR,
  UG,
  UZ,
  UY,
  FO,
  FJ,
  PH,
  FI,
  FK,
  FR,
  GF,
  PF,
  TF,
  HR,
  CF,
  TD,
  ME,
  CZ,
  CL,
  CH,
  SE,
  SJ,
  LK,
  EC,
  GQ,
  ER,
  EE,
  ET,
  ZA,
  GS,
  SS,
  JM,
  JP,
];
